import { promoApi, usePromo } from '@entities/promo-video';
import { useEffect, useState } from 'react';
import { xhr } from '@shared/config';
import type { PromoVideo } from '@shared/types/promo-videos';

export const usePromoLoader = (id: number) => {
  const { setPromo } = usePromo(id);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loader = () => {
      const controller = new AbortController();
      const loadPromo = async () => {
        // console.log('try to load promo');
        if (!id || isNaN(id)) return;

        setIsLoading(true);
        try {
          const res = await xhr.get<PromoVideo>(`${promoApi}${id}/`, {
            signal: controller.signal,
          });

          if (!res.data) throw res;

          setPromo(res.data);
        } catch (error) {
          console.error(error);
        } finally {
          setIsLoading(false);
        }
      };

      loadPromo();

      return () => {
        controller.abort();
      };
    };

    loader();
  }, [id]);
  return {
    isLoading,
  };
};
